import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "list-actions-admin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click(_) {
        _vm.factoringProviderIdEdited = 0;
        _vm.factoringProviderDialogShown = true;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New financing option ")], 1)], 1), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      loading: _vm.isLoadingData,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.editFactoringProvider
    },
    scopedSlots: _vm._u([{
      key: "item.daysOfDelayAllowed",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.daysOfDelayAllowed > 1 ? "".concat(item.daysOfDelayAllowed, " days") : "".concat(item.daysOfDelayAllowed, " day")) + " ")];
      }
    }, {
      key: "item.deleted",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.deleted ? _c("div", {
          staticClass: "badge danger"
        }, [_vm._v("Deactivated")]) : _c("div", {
          staticClass: "badge success"
        }, [_vm._v("Activated")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            small: "",
            disabled: item.disable,
            title: "Edit"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.editFactoringProvider(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")]), !item.deleted ? _c(VIcon, {
          attrs: {
            small: "",
            disabled: item.disable,
            title: "Deactivate"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.deleteFactoringProvider(item);
            }
          }
        }, [_vm._v(" mdi-toggle-switch-off ")]) : _c(VIcon, {
          attrs: {
            small: "",
            disabled: item.disable,
            title: "Activate"
          },
          on: {
            click: function click($event) {
              return _vm.activateFactoringProvider(item);
            }
          }
        }, [_vm._v(" mdi-toggle-switch ")])], 1)])];
      }
    }], null, true)
  })], 1), _vm.factoringProviderDialogShown ? _c("FactoringProviderDialog", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      factoringProviderId: _vm.factoringProviderIdEdited,
      listChange: _vm.fetchFactoringProviders,
      close: function close(_) {
        _vm.factoringProviderDialogShown = false;
      }
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };